export const paperData = [
    {
        "lang":'fr',
        "date":'07/01/2026',
        "title":`Word Frequencer`,
        "desc":`Projet d'analyse fréquentielle dans un texte dans le cadre du cours « Initiation à la Programmation C »`,
        "googleId":`151YWMG935WfVa-OCyDVX2bnlK4Mca2QA`,
        "tags":['s3','projet','informatique','info','eiffel']
    },
    {
        "lang":'fr',
        "date":'21/12/2025',
        "title":`Mirabilis - Base de données`,
        "desc":`Rapport du projet du fin de 3ème semestre (L2) du cours de base de données.`,
        "googleId":`1eH3RUeeJZ09Q-moky-ckPaqJdsto2P_m`,
        "tags":['s3','projet','bdd','info','eiffel']
    },
    {
        "lang":'fr',
        "date":'18/05/2025',
        "title":`Map Maker - Version Longue`,
        "desc":`Rapport du projet du fin de 2ème semestre de L1 portant sur la conception d'un éditeur & générateur de cartes en 2D.`,
        "googleId":`1eOmRrH47gX5jyuqw2NmOpVr8QnwSLSw7`,
        "tags":['s2','projet','informatique','info','eiffel']
    }
]
